import _regeneratorRuntime from "babel-runtime/regenerator";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
// import styles from './styles.css';

import DiViewerMenuBar from "../di-viewer-menu-bar";
import DiBeforeAfter from "../di-before-after";
import { modes } from '../../utils';

var dimensions = new Map([['qvga', [320, 240]], ['vga', [640, 480]], ['hd', [1280, 720]]]);

var DiViewer = function (_Component) {
  _inherits(DiViewer, _Component);

  function DiViewer(props) {
    _classCallCheck(this, DiViewer);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      // dimensionRatio: props.dimensionRatio ? props.dimensionRatio : -1,
      resolution: props.resolution ? props.resolution : 'vga',
      image: {},
      clickIds: ['videoCanvas', 'imageCanvas', 'beforeAfterWrap', 'beforeCanvas', 'lineWrapper'],
      showMenuBar: true
    };

    _this.setVideo = _this.setVideo.bind(_this);
    _this.stopStreamedVideo = _this.stopStreamedVideo.bind(_this);
    _this.updateCanvasSize = _this.updateCanvasSize.bind(_this);
    _this.videoIsReady = _this.videoIsReady.bind(_this);
    _this.setImageUrl = _this.setImageUrl.bind(_this);
    _this.callback = _this.callback.bind(_this);
    _this.mouseDown = _this.mouseDown.bind(_this);
    _this.mouseUp = _this.mouseUp.bind(_this);
    _this.mouseMove = _this.mouseMove.bind(_this);
    _this.mouseLeave = _this.mouseLeave.bind(_this);
    // this.record = this.record.bind(this);
    return _this;
  }

  DiViewer.prototype.componentDidMount = function componentDidMount() {
    // document.body.addEventListener('touchmove', function (ev) { 
    //   ev.preventDefault();
    // });
    this.props.playVideo ? this.setVideo() : this.updateCanvasSize();
    window.addEventListener("resize", this.updateCanvasSize);
    this.callback({
      ids: {
        video: 'video',
        videoCanvas: 'videoCanvas',
        imageCanvas: 'imageCanvas',
        // modelCanvas: 'modelCanvas',
        beforeCanvas: 'beforeCanvas'
      }
    });
    // window.addEventListener("orientationchange", ()=>{console.log('orientationchange')});
  };

  DiViewer.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("resize", this.updateCanvasSize);
    // window.removeEventListener("orientationchange", ()=>{console.log('orientationchange')});
  };

  DiViewer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
    if (typeof this.props.playVideo == "boolean" && this.props.playVideo != prevProps.playVideo) {
      if (this.props.playVideo) {
        this.setVideo();
      } else {
        this.stopStreamedVideo();
      }
    }
    if (typeof this.props.playingRecordedVideo == 'boolean' && this.props.playingRecordedVideo != prevProps.playingRecordedVideo) {
      if (this.props.playingRecordedVideo) {
        this.videoElem.play();
      } else {
        this.videoElem.pause();
      }
    }
    if (prevProps.mode != this.props.mode && [modes.modelCanvasShowing, modes.photoCanvasShowing, modes.canvasShowing, modes.takingPhoto].indexOf(this.props.mode) >= 0) {
      if ([modes.modelCanvasShowing, modes.photoCanvasShowing, modes.canvasShowing].indexOf(this.props.mode) >= 0) {
        this.setState({ lastVisible: this.props.mode });
      }
      this.updateCanvasSize();
    }
    if (this.props.imageUrl && this.props.imageUrl != prevProps.imageUrl) {
      this.setImageUrl(this.props.imageUrl);
    }
    // if(this.props.videoSrc && this.props.videoSrc != prevProps.videoSrc){
    //   this.videoElem.play();
    //   this.callback({playingVideo: true});
    // }
    if (this.props.engineReady && this.props.dimensionRatio != prevProps.dimensionRatio) {
      this.updateCanvasSize();
    }
  };

  DiViewer.prototype.setImageUrl = function setImageUrl(imageUrl) {
    var img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      this.updateCanvasSize(img);
      this.callback({ mode: modes.imageLoaded });
    }.bind(this);
    img.src = imageUrl;
  };

  DiViewer.prototype.setVideo = function setVideo() {
    var _this2 = this;

    if (this.videoElem.srcObject == null) {
      var constraints = {
        audio: false,
        video: {
          width: { ideal: dimensions.get(this.state.resolution)[0] },
          height: { ideal: dimensions.get(this.state.resolution)[1] },
          facingMode: "user"
        }
      };
      navigator.mediaDevices.getUserMedia(constraints).then(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream) {
          var updateCanvasSize, callback, tracks;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  updateCanvasSize = this.updateCanvasSize;
                  callback = this.callback;

                  this.videoElem.srcObject = stream;
                  tracks = this.videoElem.srcObject.getTracks();

                  tracks.forEach(function (track) {
                    // updateCanvasSize();
                    // callback({mode: modes.menuShowing, cameraDenied: true});
                    track.onended = function () {
                      if (gtag) {
                        gtag('event', 'exception', {
                          'description': 'track ended, camera denied',
                          'fatal': false
                        });
                      }
                      updateCanvasSize();
                      callback({ mode: modes.menuShowing, cameraDenied: true });
                    };
                  });
                  this.videoElem.play();
                  this.callback({ playingVideo: true });

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }().bind(this)).catch(function (err) {
        console.error(err);
        _this2.updateCanvasSize();
        _this2.callback({ mode: modes.menuShowing, cameraDenied: true });
      }.bind(this));
    }
  };

  DiViewer.prototype.stopStreamedVideo = function stopStreamedVideo() {
    if (this.videoElem.srcObject != null) {
      var stream = this.videoElem.srcObject;
      var tracks = stream.getTracks();

      tracks.forEach(function (track) {
        track.stop();
      });

      this.videoElem.srcObject = null;
      this.callback({ playingVideo: false });
    }
  };

  DiViewer.prototype.videoIsReady = function videoIsReady() {
    this.updateCanvasSize(null, null, { videoIsReady: true });
  };

  DiViewer.prototype.updateCanvasSize = function updateCanvasSize(img, forceImg, callbackObj) {

    console.log('resize');

    var getSourceAndDestValuesToSlice = function getSourceAndDestValuesToSlice(srcW, srcH, dstW, dstH, flip, model, bottomMenuHeight) {
      var zoomByW = dstW / srcW;
      var zoomByH = dstH / srcH;
      var zoomBy = Math.round((zoomByH > zoomByW ? zoomByH : zoomByW) * 1000) / 1000;

      var ds = {};

      // console.log(`### bottomMenuHeight: ${bottomMenuHeight} ###`);
      var shiftModel = model && bottomMenuHeight ? -70 : 0;
      // console.log(`### shiftModel: ${shiftModel} ###`);

      var wDiff = srcW - dstW;
      var hDiff = srcH - dstH;
      var tX = wDiff / 2 * -1;
      var ty = hDiff / 2 * -1 + shiftModel; // shift up if model

      var translate = "translate(" + tX + "px, " + ty + "px)";
      var scale = "scale(" + (flip ? -1 * zoomBy : zoomBy) + ", " + zoomBy + ")";
      var transform = translate + " " + scale;

      ds.transform = transform;

      return ds;
    };

    var model = false,
        srcW = void 0,
        srcH = void 0,
        flip = false;
    if (img instanceof Image) {
      srcW = img.naturalWidth;
      srcH = img.naturalHeight;
      if (this.state.image.w != srcW || this.state.image.h != srcH) {
        this.setState({ image: { w: srcW, h: srcH } });
      }
      model = true;
    } else if (forceImg || this.state.image.w && this.props.mode == modes.modelCanvasShowing) {
      srcW = this.state.image.w;
      srcH = this.state.image.h;
      model = true;
    } else {
      srcW = this.videoElem.videoWidth;
      srcH = this.videoElem.videoHeight;
      flip = true;
    }

    var destRatio = this.props.dimensionRatio != -1 ? this.props.dimensionRatio : srcW / srcH;
    console.log(this.props.dimensionRatio, destRatio, srcW, srcH, srcW / srcH);
    var destWidth = this.container.offsetWidth;
    var destHeight = Math.ceil(destWidth / destRatio);
    if (this.state.destHeight != destHeight) {
      this.setState({ destHeight: destHeight });
    }

    var ds = getSourceAndDestValuesToSlice(srcW, srcH, destWidth, destHeight, flip, model, this.props.bottomMenuHeight);

    var response = {
      canvas: {
        width: srcW, height: srcH,
        style: { transform: ds.transform },
        ratio: destRatio
      },
      viewer: { height: destHeight, width: destWidth }
    };

    if (this.beforeCanvas.style.transform != ds.transform) {
      this.beforeCanvas.style.transform = ds.transform;
      this.videoElem.style.transform = ds.transform;
      this.vidCanvas.style.transform = ds.transform;
      this.imgCanvas.style.transform = ds.transform;
      if (img instanceof Event) {
        this.videoElem.style.transform = ds.transform;
      }
      this.callback(Object.assign(callbackObj || {}, response));
    } else if (callbackObj) {
      this.callback(callbackObj);
    }
    return response;
  };

  // async record(recorderType){
  //   this.setState({vidDim: `videoWidth: ${this.videoElem.videoWidth}, videoHeight: ${this.videoElem.videoHeight}`});
  //   //////////////////////vidDim

  //   const sleep = m => new Promise(r => setTimeout(r, m));
  //   let recorder = RecordRTC(this.videoElem.srcObject, {
  //     type: 'video',
  //     video: 'video/webm;codecs=h264',
  //     recorderType: recorderType,
  //   });
  //   recorder.startRecording();

  //   await sleep(10000);

  //   recorder.stopRecording(function () {
  //     let blob = recorder.getBlob();
  //     invokeSaveAsDialog(blob);
  //   });

  //   /////////////////////////////
  // }

  DiViewer.prototype.callback = function callback(action) {
    if (this.props.callback) {
      this.props.callback(action);
      // if(action.record){
      //   this.record(MediaStreamRecorder).catch(((err) => {
      //     this.record(WhammyRecorder);
      //   }).bind(this));

      // }
    }
  };

  DiViewer.prototype.mouseDown = function mouseDown(event) {
    if (this.state.clickIds.indexOf(event.target.id) >= 0) {
      this.mMove = false;
      this.mDown = true;
    }
  };

  DiViewer.prototype.mouseMove = function mouseMove(event) {
    if (this.state.clickIds.indexOf(event.target.id) >= 0) {
      this.mMove = this.mDown ? true : false;
    }
  };

  DiViewer.prototype.mouseLeave = function mouseLeave(event) {
    if (this.state.clickIds.indexOf(event.target.id) >= 0) {
      this.mMove = false;
      this.mDown = false;
    }
  };

  DiViewer.prototype.mouseUp = function mouseUp(event) {
    if (this.state.clickIds.indexOf(event.target.id) >= 0) {
      if (!this.mMove) {
        this.setState({ showMenuBar: !this.state.showMenuBar });
        this.callback({ click: Math.random(), showMenuBar: !this.state.showMenuBar });
      }
      this.mMove = false;
      this.mDown = false;
    }
  };

  DiViewer.prototype.render = function render() {
    var _this3 = this;

    var menuBarDisplay = this.state.destHeight > 0 && [modes.canvasShowing, modes.photoCanvasShowing, modes.videoShowing, modes.modelCanvasShowing].indexOf(this.props.mode) >= 0 && this.state.showMenuBar;
    var videoCanvasDisplay = this.state.destHeight > 0 && [modes.modelCanvasShowing, modes.canvasShowing, modes.photoCanvasShowing, modes.confirmPhoto].indexOf(this.props.mode) >= 0 ? 'block' : 'none';
    var videoVisibility = videoCanvasDisplay == 'block' ? { opacity: 0 } : {};
    // const imageCanvasDisplay = this.state.destHeight > 0 && [modes.confirmPhoto, modes.noFaceDetected].indexOf(this.props.mode) >= 0 ? 'block' : 'none';
    var imageCanvasDisplay = this.state.destHeight > 0 && [modes.noFaceDetected].indexOf(this.props.mode) >= 0 ? 'block' : 'none';
    var beforeAfterDisplay = this.state.destHeight > 0 && [modes.photoCanvasShowing, modes.modelCanvasShowing].indexOf(this.props.mode) >= 0 ? 'block' : 'none';
    // const imageModelCanvasDisplay = [modes.modelCanvasShowing].indexOf(this.props.mode) >= 0 ? 'block' : 'none';
    return React.createElement(
      "div",
      {
        id: 'diviewer',
        style: { height: this.state.destHeight + "px", visibility: this.props.engineReady ? 'visible' : 'hidden' },
        ref: function ref(c) {
          return _this3.container = c;
        },
        onTouchStart: this.mouseDown,
        onMouseDown: this.mouseDown,
        onTouchMove: this.mouseMove,
        onMouseMove: this.mouseMove,
        onTouchEnd: this.mouseUp,
        onMouseUp: this.mouseUp,
        onMouseLeave: this.mouseMove
      },
      React.createElement("video", { ref: function ref(c) {
          return _this3.videoElem = c;
        },
        id: "video",
        src: this.props.videoSrc,
        style: videoVisibility,
        muted: true, playsInline: true, loop: true, autoPlay: true,
        onCanPlay: this.videoIsReady }),
      React.createElement("canvas", { ref: function ref(c) {
          return _this3.vidCanvas = c;
        },
        id: "videoCanvas",
        className: "abste",
        style: { display: videoCanvasDisplay } }),
      React.createElement("canvas", { ref: function ref(c) {
          return _this3.imgCanvas = c;
        },
        id: "imageCanvas",
        className: "abste",
        style: { display: imageCanvasDisplay } }),
      React.createElement(
        "div",
        { className: "beforeAfterWrap", style: { display: beforeAfterDisplay } },
        React.createElement(DiBeforeAfter, {
          selectedCategory: this.props.selectedCategory,
          canvas: React.createElement("canvas", { ref: function ref(c) {
              return _this3.beforeCanvas = c;
            },
            id: "beforeCanvas",
            className: "abste" }) })
      ),
      menuBarDisplay && React.createElement(DiViewerMenuBar, {
        mode: this.props.mode,
        bottomMenuHeight: this.props.bottomMenuHeight,
        callback: this.callback })
    );
  };

  return DiViewer;
}(Component);

export { DiViewer as default };